import i18next from 'i18next'

// translate routes
const getTranslationRoutes = (routeStr) => {
  const translationPattern = /^([A-Z_]+)(\.[A-Z_]+)*$/
  return translationPattern.test(routeStr) ? i18next.t(`common:ROUTES.${routeStr}`) : routeStr
}

// translate error message codes
const getTranslationMsgCodes = (msgObj) => {
  // const missingTranslationStr = 'translationHelper : MISSING TRANSLATION MESSAGE CODE'
  const messageCode = msgObj?.messageCode
  const message = msgObj?.message

  if (!messageCode && message) return message
  if (!messageCode && !message) return

  // translate messageData if necessary
  const computedData = msgObj?.messageData?.map(data => {
    if (typeof data === 'number' || typeof data === 'boolean') return data

    return typeof data === 'object'
      ? data?.translate ? i18next.t(data?.value) : data?.value
      : i18next.t(data)
  })

  return i18next.t(`msgCodes:${messageCode}`, computedData)
}

export {
  getTranslationRoutes,
  getTranslationMsgCodes
}



/* ROUTES *****************************************/
// t('common:ROUTES.ORDERS.WHOLESALE.ACTIVE_ORDERS')
// t('common:ROUTES.ORDERS.WHOLESALE.ARCHIVED_ORDERS')



/* ERRORS *****************************************/
/* Generic Errors */
// t('msgCodes:ITS_BE_ERROR_NOT_FOUND')
// t('msgCodes:ITS_BE_ERROR_NOT_AUTHORIZED')
// t('msgCodes:ITS_BE_ERROR_EXPORT_ERROR')
// t('msgCodes:ITS_BE_ERROR_INVALID_USER_EMAIL')
// t('msgCodes:ITS_BE_ERROR_CANT_EDIT_FIELD')
// t('msgCodes:ITS_BE_ERROR_REQUIRED')
// t('msgCodes:ITS_BE_ERROR_MIN_LENGTH')
// t('msgCodes:ITS_BE_ERROR_MAX_LENGTH')
// t('msgCodes:ITS_BE_ERROR_BAD_REQUEST')
// t('msgCodes:ITS_BE_ERROR_MISSING_ROUTE_PARAM')

/* Orders Errors */
// t('msgCodes:ITS_BE_ERROR_INVALID_ORDER_TYPE')

// t('msgCodes:ITS_BE_ERROR_WHOLESALE_PLUTOS_ERROR')
// t('msgCodes:ITS_BE_ERROR_WHOLESALE_PLUTOS_CUSTOMER_NOT_FOUND')
// t('msgCodes:ITS_BE_ERROR_WHOLESALE_PLUTOS_REP_NOT_FOUND')
// t('msgCodes:ITS_BE_ERROR_WHOLESALE_PLUTOS_STYLE_NOT_FOUND')

// t('msgCodes:WHOLESALE_PLUTOS_ERROR_SUBMIT_AUDIT_NO_CUSTOMER')
// t('msgCodes:WHOLESALE_PLUTOS_ERROR_SUBMIT_CUSTOMER_INVALID')
// t('msgCodes:WHOLESALE_PLUTOS_ERROR_SUBMIT_CUSTOMER_STORES_INVALID')
// t('msgCodes:WHOLESALE_PLUTOS_ERROR_SUBMIT_CUSTOMER_TOKEN_MISSING')
// t('msgCodes:WHOLESALE_PLUTOS_ERROR_SUBMIT_CUSTOMER_TOKEN_INVALID')
// t('msgCodes:WHOLESALE_PLUTOS_ERROR_SUBMIT_REP1_INVALID')
// t('msgCodes:WHOLESALE_PLUTOS_ERROR_SUBMIT_REP1_MISSING')
// t('msgCodes:WHOLESALE_PLUTOS_ERROR_SUBMIT_REP1_TOKEN_INVALID')
// t('msgCodes:WHOLESALE_PLUTOS_ERROR_SUBMIT_REP2_INVALID')
// t('msgCodes:WHOLESALE_PLUTOS_ERROR_SUBMIT_REP2_TOKEN_INVALID')
// t('msgCodes:WHOLESALE_PLUTOS_ERROR_SUBMIT_SOURCE_INVALID')
// t('msgCodes:WHOLESALE_PLUTOS_ERROR_SUBMIT_SKU_DISCOUNT')
// t('msgCodes:WHOLESALE_PLUTOS_ERROR_SUBMIT_USER_TOKEN_INVALID')
// t('msgCodes:WHOLESALE_PLUTOS_ERROR_SUBMIT_SKU_DATES')
// t('msgCodes:WHOLESALE_PLUTOS_ERROR_SUBMIT_SKU_DIVISION')
// t('msgCodes:WHOLESALE_PLUTOS_ERROR_SUBMIT_SKU_PACK_CODE')
// t('msgCodes:WHOLESALE_PLUTOS_ERROR_SUBMIT_SKU_PACK_COUNT')
// t('msgCodes:WHOLESALE_PLUTOS_ERROR_SUBMIT_SKU_PROMO')
// t('msgCodes:WHOLESALE_PLUTOS_ERROR_SUBMIT_SKU_SIZE')
// t('msgCodes:WHOLESALE_PLUTOS_ERROR_SUBMIT_SKU_TERM')
// t('msgCodes:WHOLESALE_PLUTOS_ERROR_SUBMIT_SKU_TERM_REDUCED')
// t('msgCodes:WHOLESALE_PLUTOS_ERROR_SUBMIT_SKU_TOKEN_INVALID')

/* Dynamic Field Errors */
// t('msgCodes:DYNAMIC_FIELDS.REGION')
